import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import p from "./styles/index.cssr.js";
import l from "../../_mixins/use-theme.js";
import h from "../../_mixins/use-config.js";
import g from "../styles/light.js";
import { useThemeClass as v } from "../../_mixins/use-css-vars-class.js";
import { formatLength as C } from "../../_utils/css/format-length.js";
import { warn as b } from "../../_utils/naive/warn.js";
import { defineComponent as _, computed as m, h as d, mergeProps as $ } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const y = Object.assign(Object.assign({}, l.props), {
  depth: [String, Number],
  size: [Number, String],
  color: String,
  component: [Object, Function]
}), T = _({
  _n_icon__: !0,
  name: "Icon",
  inheritAttrs: !1,
  props: y,
  setup(e) {
    const {
      mergedClsPrefixRef: o,
      inlineThemeDisabled: i
    } = h(e), r = l("Icon", "-icon", p, g, e, o), s = m(() => {
      const {
        depth: t
      } = e, {
        common: {
          cubicBezierEaseInOut: c
        },
        self: a
      } = r.value;
      if (t !== void 0) {
        const {
          color: f,
          [`opacity${t}Depth`]: u
        } = a;
        return {
          "--n-bezier": c,
          "--n-color": f,
          "--n-opacity": u
        };
      }
      return {
        "--n-bezier": c,
        "--n-color": "",
        "--n-opacity": ""
      };
    }), n = i ? v("icon", m(() => `${e.depth || "d"}`), s, e) : void 0;
    return {
      mergedClsPrefix: o,
      mergedStyle: m(() => {
        const {
          size: t,
          color: c
        } = e;
        return {
          fontSize: C(t),
          color: c
        };
      }),
      cssVars: i ? void 0 : s,
      themeClass: n == null ? void 0 : n.themeClass,
      onRender: n == null ? void 0 : n.onRender
    };
  },
  render() {
    var e;
    const {
      $parent: o,
      depth: i,
      mergedClsPrefix: r,
      component: s,
      onRender: n,
      themeClass: t
    } = this;
    return !((e = o == null ? void 0 : o.$options) === null || e === void 0) && e._n_icon__ && b("icon", "don't wrap `n-icon` inside `n-icon`"), n == null || n(), d("i", $(this.$attrs, {
      role: "img",
      class: [`${r}-icon`, t, {
        [`${r}-icon--depth`]: i,
        [`${r}-icon--color-transition`]: i !== void 0
      }],
      style: [this.cssVars, this.mergedStyle]
    }), s ? d(s) : this.$slots);
  }
});
export {
  T as NIcon,
  y as iconProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/icon/src/Icon.js
// module id = 918
// module chunks = 41